<template>
    <div>

        <v-form>
            <ComunDialogComp v-model="estadoComp" maxWidth="1200" @close-modal="CerrarModal"
                :title='"Reprogramar la evaluación"' :classCardText="'pt-0'">

                <template v-slot:body>

                    <!-- TÍTULO -->
                    <div>
                        <v-chip small dark class="font-weight-black pa-5 ma-3" :color="parametros.items.color_nivel">
                            <h2> {{ parametros.items.desc_curso }}</h2>
                            <v-icon> {{ parametros.items.icono_curso }} </v-icon>
                        </v-chip>
                    </div>

                    <!-- DATA EVALUACIÓN -->
                    <div>

                        <!-- NOMBRE EVALUACION - NIVEL - GRADO - SECCIÓN -->
                        <v-row>
                            <v-col cols="12" md="3">
                                <textfieldComp textLabel="Nombre de la Evaluación" type="text"
                                    v-model="parametros.items.nombre_evaluacion" disabled />
                            </v-col>

                            <v-col cols="12" md="3">
                                <textfieldComp textLabel="Nivel" type="text" v-model="parametros.items.desc_nivel"
                                    disabled />
                            </v-col>

                            <v-col cols="12" md="3">
                                <textfieldComp textLabel="Grado" type="text" v-model="parametros.items.desc_grado"
                                    disabled />
                            </v-col>

                            <v-col cols="12" md="3">
                                <textfieldComp text-label="Sección" type="text"
                                    v-model="parametros.items.nombre_seccion" disabled />
                            </v-col>
                        </v-row>

                        <!-- FECHA PROGRAMACIÓN - HORA INICIO - HORA FIN -->
                        <v-row>

                            <v-col cols="12" md="4">
                                <v-menu min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :rules="validationRules.validateCampo" v-on="on"
                                            v-model="parametros.items.fecha" label="Fecha de Reprogramación"
                                            v-bind="attrs" prepend-icon="mdi-calendar" readonly>
                                        </v-text-field>
                                    </template>

                                    <v-date-picker v-model="parametros.items.fecha" :min="nowDate"
                                        :max="lastPeriodDate">
                                    </v-date-picker>

                                </v-menu>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field step="1" :rules="validationRules.validateCampo"
                                    v-model="parametros.items.hora_inicio" label="Hora Inicio"
                                    type="time"></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field step="1" :rules="validationRules.validateCampo" v-model="parametros.items.hora_fin"
                                    label="Hora Fin" type="time"></v-text-field>
                            </v-col>                           

                        </v-row>
                    </div>

                    <!-- TABLA ESTUDIANTES A REPROGRAMAR EVALUACIÓN -->
                    <div>
                        <v-data-table :headers="headers" :items="AlumnosSeccion" :hide-default-footer="true"
                            class="elevation-1 black--text">

                            <template v-slot:[`header.check`]>
                                SELECCIONAR <br />
                                <v-simple-checkbox @click="SelectAll" v-model="allSelected"></v-simple-checkbox>
                            </template>

                            <template v-slot:[`item.observacion`]="{ item }">
                                <v-text-field v-model="item.observacion_docente" label="Observación" class="pb-0 pt-1"
                                    type="text" dense single-line :disabled="item.alumno_check == false"></v-text-field>
                            </template>

                            <template v-slot:[`item.check`]="{ item }">
                                <v-simple-checkbox v-model="item.alumno_check"></v-simple-checkbox>
                            </template>

                        </v-data-table>
                    </div>

                    <!-- GUARDAR -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <TableButtonComp normalButton @click="reprogramarEval()" textButton="Reprogramar" />
                    </v-card-actions>

                </template>
            </ComunDialogComp>
        </v-form>

    </div>
</template>
<script>
import axios from "@/helpers/axios";
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { validationRules } from "../../../../helpers/validatorHelpers";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import { mapMutations } from "vuex";

export default {
    name: 'ReprogramarEvaluacionComp',
    components: {
        ComunDialogComp,
        textfieldComp,
        TableButtonComp
    },
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        }
    },

    // Montador
    mounted() {

        console.log('parametros', this.parametros);
        this.getStudents();
        this.getPeriodDays();
    },

    // Watch
    watch: {
        estadoComp() {
            if (this.estadoComp) {
                this.getStudents();
            }
        }
    },

    // Computed
    computed: {
        validationRules() {
            return validationRules;
        }
    },

    // Data
    data: () => ({
        nowDate: new Date().toISOString().slice(0, 10),
        lastPeriodDate: null,
        datePicked: "",
        horaInicio: "",
        horaFin: "",
        AlumnosSeccion: [],
        headers: [
            { text: 'Nº. de documento de identidad', value: 'numdoc_alumno', class: 'secondary black--text' },
            { text: 'Apellidos y nombres', value: 'nombre_apellido_alumno', class: 'secondary black--text' },
            { text: 'Observación', value: 'observacion', class: 'secondary black--text', sortable: false },
            { text: 'Seleccionar', value: 'check', align: 'center', class: 'secondary black--text', sortable: false },
        ],
        allSelected: false,
    }),

    methods: {

        // Peticiones al back
        async getStudents() {
            try {
                let filter = {
                    id_ano_lectivo: this.parametros.items.id_ano_lectivo,
                    id_colegio: this.parametros.items.id_colegio,
                    id_seccion: this.parametros.items.id_seccion,
                    id_usuario: sessionStorage.id,
                    id_evaluacion: this.parametros.items.id,
                };

                let response = await axios.post('/evaluacion/alumnos/', filter);

                this.AlumnosSeccion = response.data.SeccionAlumno;
            } catch (error) {
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al traer los estudiantes de esa evaluación.',
                    tiempo: 5000,
                });
            }
        },

        async getPeriodDays() {
            try {
                const response = await axios.get(`/administrativo/periodo/ultimo-dia-periodo-actual/${this.parametros.items.id_colegio}/${this.parametros.items.id_ano_lectivo}/${this.parametros.items.id_nivel}`);

                this.lastPeriodDate = response.data.last_day;
            } catch (error) {
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error el último día del periodo actual.',
                    tiempo: 5000,
                });
            }

        },

        async reprogramarEval() {


            try {
                //let hora_actual = `${new Date().getHours()}:${new Date().getMinutes()}`;
                let ahora = new Date();
                let hora_actual = `${ahora.getHours().toString().padStart(2, '0')}:${ahora.getMinutes().toString().padStart(2, '0')}`;

                // Validación para evitar que se reprograme en una fecha antes de la actual
                if (this.nowDate > this.parametros.items.fecha) {
                    this.setEnviarMens({
                        tipo: 'W',
                        mensaje: 'La fecha de la reprogramación no puede ser antes de la fecha actual.',
                        tiempo: 4000
                    })

                    return
                }

                // Validación para evitar que la hora_inicio <= hora actual
                if (hora_actual >= this.parametros.items.hora_inicio) {
                    this.setEnviarMens({
                        tipo: 'W',
                        mensaje: 'La hora de la reprogramación tiene que ser después de la hora actual.',
                        tiempo: 4000
                    })

                    return
                }

                // Validación para evitar que la hora_fin >= hora_inicio
                if (this.parametros.items.hora_inicio >= this.parametros.items.hora_fin) {
                    this.setEnviarMens({
                        tipo: 'W',
                        mensaje: 'La hora de inicio no puede ser mayor a la hora de fin.',
                        tiempo: 4000
                    })

                    return
                }

                let data = {
                    evaluacion: this.parametros.items,
                    fecha: this.parametros.items.fecha,
                    hora_inicio: this.parametros.items.hora_inicio,
                    hora_fin: this.parametros.items.hora_fin,
                    alumnos: this.AlumnosSeccion
                }

                const response = await axios.put('/evaluacion/programacion/reprogramarEval', data);

                this.setEnviarMens({
                    tipo: response.data.messageT,
                    mensaje: response.data.message,
                    tiempo: 5000,
                });

                this.CerrarModal();

            } catch (error) {
                this.setEnviarMens({
                    tipo: 'E',
                    mensaje: 'Error al reprogramar la evaluación.',
                    tiempo: 5000,
                });
            }
        },

        // Fns() de apoyo
        CerrarModal() {
            this.$emit('close')
            this.datePicked = "",
            this.horaInicio = "",
            this.horaFin = "",
            this.AlumnosSeccion = [];
        },

        SelectAll() {
            if (this.allSelected) {
                this.AlumnosSeccion.forEach((item) => {
                    item.alumno_check = true
                });
            } else {
                this.AlumnosSeccion.forEach((item) => {
                    item.alumno_check = false
                });
            }
        },

        // Mensajes de Alertas
        ...mapMutations("mensajeSis", ["setEnviarMens"]),
    },
}

</script>
